<template>
  <div>
    <div class="row g-1">
      <div v-for="(permission, index) in defaultPermissions" :key="index">
        <div class="form-check mb-2">
          <input
            :id="index"
            v-model="permissions"
            :data-test="index"
            name="permission"
            type="radio"
            :checked="permission.value === value"
            :value="permission.value"
            class="form-check-input"
          />
          <label class="form-check-label" :for="index">
            {{ permission.label }}
          </label>
          <div class="form-text text-secondary">{{ permission.translation }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PermissionList',
  props: {
    permissionData: {
      type: [String, Number],
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    isCourse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      networkPermissionHelpText: this.title ? this.title : this.$t('network.default-media-permission.helptext'),
      defaultPermissions: [
        {
          label: this.$t('default-media-permission.public'),
          value: 'public',
          translation: this.isCourse ? 'Public courses are visible to everyone using Networks.' : this.$t('default-media-permission.public.helptext'),
        },
        {
          label: this.$t('default-media-permission.authorized'),
          value: 'authorized',
          translation: this.isCourse ? 'Authorized courses are only visible to users that are signed in with a Resonance account.' : this.$t('default-media-permission.authorized.helptext'),
        },
        {
          label: this.$t('default-media-permission.private'),
          value: 'private',
          translation: this.isCourse ? 'Visibility will be restricted to members of the course networks.' : this.$t('default-media-permission.private.helptext'),
        },
        {
          label: this.$t('default-media-permission.unlisted'),
          value: 'unlisted',
          translation: this.$t('default-media-permission.unlisted.helptext'),
        },
      ],
    };
  },
  computed: {
    permissions: {
      get() {
        return this.value;
      },
      set(permissions) {
        this.$emit('input', permissions);
      },
    },
  },
};
</script>
